import { render, staticRenderFns } from "./PenaltyPaymentModal.vue?vue&type=template&id=2f82c61a&scoped=true&"
import script from "./PenaltyPaymentModal.vue?vue&type=script&lang=js&"
export * from "./PenaltyPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./PenaltyPaymentModal.vue?vue&type=style&index=0&id=2f82c61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82c61a",
  null
  
)

export default component.exports